import React, { Component } from 'react';
import style from './sidebar.scss';
import classes from 'cssClasses';
import { Link } from 'react-router-dom';

class Sidebar extends Component{
	render() {
		return( 
	    <div className={classes('sidebar-sticky',style)}>
		    <ul className={classes('nav flex-column',style)}>
		    	<li className={classes('nav-item',style)}>
		    		<Link to="/admin" className={classes('nav-link',style)}>Homepage</Link>
		    	</li>
		    	<li className={classes('nav-item',style)}>
		    		<Link to="/admin/badgeclasses" className={classes('nav-link',style)}>Add badge</Link>
		    	</li>
		    </ul>
    	</div>
		);
	}
}


export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Backend/Layout/Sidebar/Sidebar.js